<template>
  <div>
    <PCNavbar class="hidden-xs-only none_992" />
    <MobileNavBar class="hidden-md-and-up" />
    <TitleComponent class="hidden-xs-only none_992" v-if="Object.keys(pageData).length" :detData="pageData" />
    <TitleComponentMobile class="hidden-md-and-up" v-if="Object.keys(pageData).length" :detData="pageData" />
    <DetailBody :detData="pageData" class="hidden-xs-only none_992" />
    <DetailBodyMobile :detData="pageData" class="hidden-md-and-up" />
    <CallMe class="hidden-xs-only none_992" />
    <MobileCallme class="hidden-md-and-up" />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import TitleComponent from '@/components/titleComponent/index'
import DetailBody from '@/components/detailBody/index' // 新增导入
import DetailBodyMobile from '@/components/DetailBodyMobile/index' // 新增导入
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/callMeMile.vue'
import { caseGetById } from "@/api/dataManeger.js";
import TitleComponentMobile from '@/components/titleComponentMobile/index'

export default {
  components: {
    PCNavbar,
    TitleComponent,
    MobileNavBar,
    MobileCallme,
    TitleComponentMobile,
    DetailBodyMobile,
    DetailBody, // 注册新组件
    CallMe,
  },
  data() {
    return {
      selectedText: '', // 初始化 selectedText
      currentSource: '', // 用于存储当前的 source 参数
      currId: '',
      pageData: {}
    };
  },
  created() {
    // 模拟从 localstory 获取数据
    this.selectedText = localStorage.getItem('selectedText') || '';
    this.currentSource = new URLSearchParams(window.location.search).get('source') || '';
    this.currId = new URLSearchParams(window.location.search).get('id') || '';
  },
  watch: {
    // 监听路由变化
    '$route'(to, from) {
      const newSource = to.query.source || ''; // 获取新的 source 参数
      this.currentSource = newSource;
      this.currId = to.query.id || '';
      // 这里可以执行相应的操作
    }

  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
    // 初始化时手动触发一次更新
    this.selectedText = localStorage.getItem('selectedText') || '';
    this.getCaseDetail()
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    async getCaseDetail() {
      caseGetById({ id: this.currId }).then((res) => {
        if (res) {
          this.pageData = res.result;
        }
      })
    },
    handleStorageChange(event) {

      if (event.key === 'selectedText') {
        const newValue = localStorage.getItem('selectedText') || '';
        if (newValue !== this.selectedText) {
          this.selectedText = newValue; // 更新 selectedText，触发监听
        }
      }
    },
    safeNavigateTo(route) {
      if (this.$route.fullPath !== route) {
        this.$router.push(route).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>